import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { CharlieButton, CharlieSpinner } from '@ver.id/libs.ui.charlie';
import { useTranslation } from '../../../i18n/i18n';
import HostedStatusBlock from '../../../components/hosted/StatusBlock';

type Props = {
  pairingCode: string;
  onCancel: () => void;
  onCompletePairing: () => void;
  onBack?: () => void;
};

export default function HostedAppPairingScreen({
  pairingCode,
  onCancel,
  onCompletePairing,
  onBack,
}: Props) {
  const { t } = useTranslation();

  return (
    <HostedStatusBlock
      visual={<CharlieSpinner className="text-muted-foreground" />}
      title={t('pairing.title')}
      subtitle={t('pairing.hint')}
    >
      {pairingCode && (
        <div className="flex flex-col items-center gap-3">
          <p className="text-sm text-muted-foreground">
            {t('pairing.codeLabel')}
          </p>
          <span className="text-2xl font-mono font-bold tracking-widest text-foreground">
            {pairingCode}
          </span>
          <CharlieButton
            className="w-full max-w-xs"
            onClick={onCompletePairing}
          >
            {t('pairing.confirm')}
          </CharlieButton>
        </div>
      )}
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <FontAwesomeIcon icon={faArrowRightArrowLeft} className="size-4" />
          {t('agentStart.changeApp')}
        </button>
      )}
      <CharlieButton
        variant="outline"
        className="w-full max-w-xs"
        onClick={onCancel}
      >
        {t('agentStart.cancel')}
      </CharlieButton>
    </HostedStatusBlock>
  );
}
